/* 集合页 / 搜索页：筛选、排序、分页无刷新更新（配合 snippets/fn-results-toolbar.liquid） */
(function(){
  /* 无刷新筛选/排序/分页：Section Rendering API 取回本模块 HTML 后替换；失败时退回整页跳转 */
  var busy = null;
  function load(sec, url, push){
    var u = new URL(url, location.href);
    u.searchParams.set('section_id', sec.dataset.section);
    var open = Array.prototype.map.call(sec.querySelectorAll('.fn-col__f[open]'), function(d){ return d.dataset.key; });
    if (busy) busy.abort();
    busy = new AbortController();
    sec.classList.add('is-busy');
    fetch(u.toString(), { signal: busy.signal })
      .then(function(r){ if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-fn-col] [data-fn-col-body]');
        var cur = sec.querySelector('[data-fn-col-body]');
        if (!fresh || !cur) throw new Error('section');
        cur.replaceWith(fresh);
        more(sec);
        open.forEach(function(k){ var d = sec.querySelector('.fn-col__f[data-key="' + k + '"]'); if (d) d.open = true; });
        if (push) history.pushState({ fnCol: true }, '', url);
        sec.classList.remove('is-busy');
      })
      .catch(function(e){ if (e.name !== 'AbortError') location.href = url; });
  }
  /* 无限滚动：哨兵进入视口附近时取下一页，把卡片追加到网格，再换上新的哨兵 */
  function more(sec){
    var box = sec.querySelector('[data-fn-col-more]');
    if (!box || box.dataset.fnObs) return; box.dataset.fnObs = '1';
    var link = box.querySelector('[data-fn-col-more-link]');
    function next(){
      if (box.classList.contains('is-loading')) return;
      box.classList.add('is-loading');
      var u = new URL(link.href, location.href);
      u.searchParams.set('section_id', sec.dataset.section);
      fetch(u.toString())
        .then(function(r){ if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function(html){
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var grid = sec.querySelector('[data-fn-col-grid]');
          var fresh = doc.querySelector('[data-fn-col-grid]');
          if (!grid || !fresh) throw new Error('grid');
          while (fresh.firstElementChild) grid.appendChild(fresh.firstElementChild);
          if (io) io.disconnect();
          var nb = doc.querySelector('[data-fn-col-more]');
          if (nb) { box.replaceWith(nb); more(sec); } else box.remove();
        })
        .catch(function(){ box.classList.remove('is-loading'); });
    }
    link.addEventListener('click', function(e){ e.preventDefault(); next(); });
    var io = null;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function(es){ if (es[0].isIntersecting) next(); }, { rootMargin: '600px 0px' });
      io.observe(box);
    }
  }
  function formUrl(form){
    var p = new URLSearchParams();
    new FormData(form).forEach(function(v, k){ if (v !== '') p.append(k, v); });
    var q = p.toString();
    return form.getAttribute('action') + (q ? '?' + q : '');
  }
  function init(sec){
    if (sec.dataset.fnReady) return; sec.dataset.fnReady = '1';
    more(sec);
    sec.addEventListener('change', function(e){
      var form = e.target.closest('[data-fn-col-form]'); if (!form) return;
      if (e.target.type === 'number') return; /* 价格在点「Appliquer」或回车时提交 */
      if (e.target.matches('[data-fn-col-sort]')) { var n = sec.querySelector('[data-fn-col-sort-name]'); if (n) n.textContent = e.target.selectedOptions[0].text; }
      load(sec, formUrl(form), true);
    });
    sec.addEventListener('submit', function(e){
      var form = e.target.closest('[data-fn-col-form]'); if (!form) return;
      e.preventDefault(); load(sec, formUrl(form), true);
    });
    sec.addEventListener('click', function(e){
      var a = e.target.closest('a[data-fn-col-link]');
      if (a && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
        e.preventDefault(); load(sec, a.href, true);
        if (a.closest('.fn-col__pag')) sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      /* 同时只展开一个筛选面板 */
      var s = e.target.closest('.fn-col__f > summary');
      if (s) sec.querySelectorAll('.fn-col__f[open]').forEach(function(d){ if (d !== s.parentElement) d.open = false; });
    });
    document.addEventListener('click', function(e){
      if (!sec.contains(e.target) || !e.target.closest('.fn-col__f')) sec.querySelectorAll('.fn-col__f[open]').forEach(function(d){ d.open = false; });
    });
    document.addEventListener('keydown', function(e){
      if (e.key !== 'Escape') return;
      var d = sec.querySelector('.fn-col__f[open]'); if (!d) return;
      d.open = false; d.querySelector('summary').focus();
    });
    window.addEventListener('popstate', function(){ load(sec, location.href, false); });
  }
  document.querySelectorAll('[data-fn-col]').forEach(init);
  document.addEventListener('shopify:section:load', function(){ document.querySelectorAll('[data-fn-col]').forEach(init); });
})();
